import { gameColorsCodes } from '../enums/gameColors';
import { COLORS } from '../enums/color';

export const colorToOddMapper = (result) => {
  for (const key in COLORS) {
    if (Object.hasOwnProperty.call(COLORS, key)) {
      if (COLORS[key] === gameColorsCodes[result?.color]) {
        return key;
      }
    }
  }
};
